import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IComponentProps } from './index';

export const generate = (
  props?: Partial<IComponentSchema<IComponentProps>>
): IComponentSchema<IComponentProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Card',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Card,
    'x-component-props': {
      title: 'Card title',
      size: 'default',
      variant: 'outlined',
      hoverable: false,
      loading: false,
      visible: true,
    },
    'x-component-props-config': {},
  };
};
